module.exports = __webpack_public_path__ + "static/media/Visualisation.5b055041.png";